var _g, _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirdiaryEnvironment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 680 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23,0,0,3.23,-67.53,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,118L25,100L125,0L225,100L225,118L125,18L25,118Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23,0,0,3.23,-67.53,-5.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204,101L204,245L46,245L46,101L125,22L204,101Z",
    style: {
      fill: "rgb(3,95,15)",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05947,0,0,1.12035,-18.6985,-68.1003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g513",
    transform: "matrix(1.19205,0,0,-1.19205,-589.498,3255.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g515"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.11,2485.76C621.649,2485.76 608.304,2472.41 608.304,2455.95L608.304,2172.78C608.304,2156.32 621.649,2142.97 638.11,2142.97L978.412,2142.97C994.873,2142.97 1008.22,2156.32 1008.22,2172.78L1008.22,2455.95C1008.22,2472.41 994.873,2485.76 978.412,2485.76L638.11,2485.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g521",
    transform: "matrix(1,0,0,1,762.847,2200.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path523",
    d: "M0,0C27.746,13.703 38.713,45.575 25.033,72.743C11.993,98.634 -20.29,109.704 -46.046,97.118C-73.457,83.721 -84.818,51.979 -71.722,25.381C-58.139,-2.205 -26.87,-13.269 0,0M59.604,90.516C41.695,79.843 36.941,71.799 40.654,56.633C47.486,28.743 28.783,-4.431 1.774,-15.67C-4.008,-18.077 -5.482,-20.418 -4.907,-26.609C-1.397,-64.483 -5.389,-101.56 -20.588,-136.675C-45.374,-193.935 -88.685,-226.054 -147.005,-242.96C-151.172,-244.168 -167.57,-248.922 -172.001,-250.206C-201.161,-258.661 -192.827,-256.246 -217.823,-263.492C-259.481,-275.567 -271.979,-279.19 -296.972,-286.435C-301.139,-287.643 -305.303,-288.85 -305.303,-288.85C-312.418,-279.482 -320.105,-268.756 -329.066,-257.888C-310.048,-248.363 -259.622,-241.974 -240.817,-234.456C-186.103,-212.584 -146.608,-183.43 -121.907,-133.894C-95.814,-81.567 -86.139,-26.274 -96.676,32.066C-102.212,62.719 -88.639,90.831 -63.283,105.25C-36.884,120.263 12.254,139.941 36.218,120.064C39.025,117.734 23.034,94.569 26.456,94.975C33.412,95.797 45.72,91.086 52.693,91.757C53.49,91.389 58.808,90.884 59.604,90.516",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g525",
    transform: "matrix(1,0,0,1,753.177,2070.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path527",
    d: "M0,0C2.497,17.175 7.452,33.9 8.952,51.282C10.366,67.674 10.65,84.03 9.68,100.434C9.482,103.791 8.773,107.048 12.988,109.1C28.74,116.776 40.629,128.812 50.488,144.388C56.9,136.766 58.527,127.894 60.78,119.784C70.608,84.407 75.787,48.691 66.594,12.115C64.891,5.343 66.149,-2.154 62.158,-8.524C54.771,-3.197 58.003,-11.781 57.722,-12.728C55.743,-19.414 50.59,-21.552 44.793,-22.706C41.7,-23.321 37.426,-24.914 36.037,-20.305C33.211,-10.928 26.351,-8.019 17.609,-8.127C10.324,-8.215 5.111,-4.346 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g529",
    transform: "matrix(1,0,0,1,760.463,2082.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path531",
    d: "M0,0C4.416,-3.756 8.921,-7.098 15.219,-7.021C22.771,-6.931 28.701,-9.442 31.144,-17.546C32.343,-21.532 36.037,-20.154 38.71,-19.621C43.719,-18.624 48.172,-16.778 49.884,-10.998C50.125,-10.179 47.333,-2.764 53.717,-7.367C45.604,-39.249 30.861,-67.808 10.423,-93.498C8.666,-95.703 7.254,-98.289 3.336,-97.325C-17.354,-92.245 -38.557,-91.755 -61.634,-90.958C-30.314,-66.679 -11.358,-35.838 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g533",
    transform: "matrix(1,0,0,1,752.912,2276.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path535",
    d: "M0,0C2.75,-6.735 -0.848,-14.474 -7.991,-17.201C-14.363,-19.633 -22.212,-16.104 -24.746,-9.675C-27.405,-2.917 -24.35,4.153 -17.527,7.021C-10.474,9.986 -2.823,6.922 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g537",
    transform: "matrix(1.19205,0,0,-1.19205,-589.498,3255.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g545",
    transform: "matrix(1,0,0,1,918.024,2404.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path547",
    d: "M0,0C9.065,-8.932 16.251,-19.179 21.523,-30.764C27.519,-43.948 30.583,-57.784 30.753,-72.258C30.807,-76.904 27.334,-80.277 22.89,-80.028C19.261,-79.826 16.294,-76.975 15.996,-73.301C15.71,-69.744 15.673,-66.163 15.25,-62.626C13.68,-49.496 9.289,-37.352 2.217,-26.169C-2.557,-18.621 -8.362,-11.968 -15.14,-6.185C-22.975,0.502 -31.728,5.661 -41.391,9.278C-51.503,13.065 -61.948,14.89 -72.731,14.882C-77.658,14.879 -81.074,18.601 -80.51,23.309C-80.079,26.932 -76.819,29.696 -72.984,29.71C-60.33,29.755 -48.061,27.624 -36.204,23.173C-28.44,20.259 -21.138,16.461 -14.287,11.778C-9.167,8.28 -4.408,4.357 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g549",
    transform: "matrix(1,0,0,1,895.937,2384.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path551",
    d: "M0,0C15.165,-15.511 22.535,-32.564 22.958,-52.569C23.043,-56.699 19.905,-60.114 15.959,-60.216C11.591,-60.333 8.215,-57.192 8.144,-52.872C7.988,-43.109 5.655,-33.922 0.961,-25.342C-3.016,-18.071 -8.308,-11.914 -14.899,-6.922C-25.441,1.066 -37.372,5.031 -50.61,5.017C-53.819,5.014 -56.56,6.829 -57.694,9.689C-58.833,12.56 -58.11,15.834 -55.783,17.943C-54.502,19.103 -52.968,19.78 -51.202,19.82C-44.113,19.967 -37.165,19.015 -30.348,17.101C-22.518,14.905 -15.222,11.517 -8.603,6.806C-5.168,4.36 -1.973,1.573 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g553",
    transform: "matrix(1,0,0,1,876.606,2361.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path555",
    d: "M0,0C7.739,-7.886 12.212,-18.028 12.368,-29.976C12.43,-34.801 8.147,-38.256 3.441,-37.304C0.111,-36.629 -2.339,-33.758 -2.415,-30.234C-2.54,-24.395 -4.144,-19.04 -7.464,-14.224C-10.763,-9.437 -15.137,-5.987 -20.531,-3.832C-24.015,-2.438 -27.652,-1.933 -31.385,-1.84C-36.947,-1.701 -40.343,4.048 -37.76,8.977C-36.493,11.392 -34.418,12.849 -31.643,12.917C-25.033,13.082 -18.714,11.73 -12.711,8.94C-8.203,6.849 -4.19,4.042 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g557",
    transform: "matrix(1,0,0,1,855.238,2321.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path559",
    d: "M0,0C-5.057,-5.221 -13.564,-5.326 -18.831,-0.23C-24.137,4.904 -24.293,13.368 -19.174,18.663C-13.997,24.024 -5.465,24.197 -0.198,19.052C5.142,13.836 5.23,5.403 0,0",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdiaryEnvironment);
export default __webpack_public_path__ + "static/media/Birdiary_Environment.fa473b72fbf22b489907071a48cdd7b2.svg";
export { ForwardRef as ReactComponent };